<script setup lang="ts">
import { ref, watch } from "vue";

const props = withDefaults(
	defineProps<{
		defaultOpen?: boolean;
		autoHierarchy?: boolean;
	}>(),
	{
		defaultOpen: false,
		autoHierarchy: true,
	}
);

const open = ref(props.defaultOpen);
const emit = defineEmits<{
	(evt: "update:open", val: boolean): void;
}>();

watch(open, () => emit("update:open", open.value));

function handleToggle(event: ToggleEvent) {
	if (event.target == null || !(event.target instanceof HTMLDetailsElement)) {
		return;
	}

	open.value = event.target.open;
}
</script>

<template>
	<li>
		<details class="group w-full" :open="open" @toggle="handleToggle">
			<summary class="pl-2">
				<slot name="trigger" />
			</summary>
			<ul
				:class="{
					'mt-1 flex flex-col gap-1': true,
					'ml-0 pl-0 before:w-0': !autoHierarchy,
				}"
			>
				<slot />
			</ul>
		</details>
	</li>
</template>
